import Clipboard from "clipboard";

export default function handleClipboard(
  text: string,
  event: any,
  clipboardSuccess: () => void,
  clipboardError: () => void
) {
  const clipboard = new Clipboard(event.target, {
    text: () => text
  });
  clipboard.on("success", () => {
    clipboardSuccess();
    clipboard.destroy();
  });
  clipboard.on("error", () => {
    clipboardError();
    clipboard.destroy();
  });
  // eslint-disable-next-line
  // @ts-ignore
  clipboard.onClick(event);
}
